// import fromPairs from 'lodash/fromPairs';

import { useContext } from 'react';
import { useIntl } from 'react-intl';

import Poll from '@/components/polls/Poll';
import { PreSignupFlowContext } from '@/components/PreSignupFlow/PreSignupProvider';
import { useAnalytics } from '@/hooks/analytics';

import { getChoicesFromTiles, onSelectChoice } from '../utils';

interface Props {
	compact?: boolean;
}

const PollMultiClick = ({ compact }: Props) => {
	const { formatMessage } = useIntl();
	const { logEvent, logEventAsync } = useAnalytics();
	const { nextScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { cta, questionType, tiles, question } = ActiveScreen;

	async function onComplete(choiceIds: string[]): Promise<void> {
		if (!tiles) {
			return;
		}
		const selectedTilesArr = tiles.filter(tile => choiceIds.includes(tile.id));
		// const selectedTiles = fromPairs(selectedTilesArr.map(tile => [tile.id, tile]));
		const sortedTiles = selectedTilesArr.sort((a, b) => (a.index as number) - (b.index as number));
		const answers = sortedTiles.map(({ id }) => id);

		logEvent({
			eventName: 'FTUE : Intro Questions : Proceeded',
			eventProps: {
				choices: answers,
				num_choices: answers.length,
				question_type: questionType as string,
			},
		});
		nextScreen();
	}

	return (
		<Poll
			title={question && formatMessage(question)}
			subtitle={cta && formatMessage(cta)}
			choices={getChoicesFromTiles(tiles, formatMessage)}
			onSelectChoice={(choiceId: string) => onSelectChoice(choiceId, questionType, logEventAsync)}
			onComplete={onComplete}
			compact={compact}
			isMultiSelect
		/>
	);
};

export default PollMultiClick;
